var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { SideImageLayout } from 'hx-ui';
import { pageImages } from '@/pages/images';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { WelcomePageLayoutContent } from '@/components/welcome-page/components/welcome-page-layout-content.component';
import { ClientLogo } from '@/components/client-logo';
import { WelcomeFooter } from '@/components/welcome-page/components/welcome-footer.component';
var imagesToPreload = {
    desktop: __spreadArray([], Object.values(pageImages), true),
};
export function WelcomePage() {
    return (_jsx(SideImageLayout, { leftPanelWidth: "40%", imageLeft: pageImages.norcStart, imageStyle: {
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
        }, overlayedContent: _jsx(OverLayBanner, { content: _jsx("span", __assign({ className: "h-6" }, { children: "Clinically validated" })), className: "bg-zinc-800 text-center text-xl font-bold text-white py-4" }), header: _jsxs("header", __assign({ className: "grid px-4 items-center justify-items-center place-content-center" }, { children: [_jsx(ClientLogo, { imageHeight: 100, imageWidth: 100 }), _jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10 mb-4" }, { children: "Hearing Test" })), _jsx(Typography, __assign({ className: "text-xl md:hidden text-norc-orange-dark leading-relaxed mb-2" }, { children: "Clinically-validated" })), _jsxs(Typography, __assign({ variant: "subhead", className: "text-lg md:text-3xl font-extrabold leading-relaxed" }, { children: ["Check your hearing in", ' ', _jsx("span", __assign({ className: "text-norc-orange-dark" }, { children: "3 minutes" }))] }))] })), content: _jsx(WelcomePageLayoutContent, {}), footer: _jsx(WelcomeFooter, { className: 'mb-5' }) }));
}
